import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useMemo } from "react";
import { useStyles } from "./styles";

type ArtImageProps = {
  name: string;
  image: string;
  onClick?: () => void;
};

export function ArtImage({
  onClick,
  name,
  image = "https://datasalesio-imagens.s3.amazonaws.com/empty_image_propaganda_02.png",
}: ArtImageProps) {
  const styles = useStyles();

  const altImage = useMemo(() => {
    return `image-${name}`;
  }, [name]);

  return (
    <Stack spacing={1}>
      <div onClick={onClick} className={styles.root}>
        <img className={styles.image} src={image} alt={altImage} />
      </div>
      <Typography variant="caption">{name}</Typography>
    </Stack>
  );
}
